import React from "react";
import classes from './ProductPreview.module.css'

const ProductPreview = (props) => {
    //Obtener Hora
    // Validar si la hora y minutos es menor a 9 para agregarle un 0 delante ej: 9:8 -> 09:08
    const currentHour = new Date().getHours() > 9 ? new Date().getHours() : '0' + new Date().getHours();
    const currentMinute = new Date().getMinutes() > 9 ? new Date().getMinutes() : '0' + new Date().getMinutes();
    return (
        <div className={classes.ProductPreview}>
            <img src={props.currentPreviewImage} alt="Product Preview" />

            { /*Condicion para validar si la seccion de latido del corazon es verdadera o falso*/
               
               props.currentSelectedFeature === 1 ?
                    <div className={classes.HeartBeatSection}>

                        <i className="fa-solid fa-heart-pulse"></i>
                        <p>78</p>
                    </div>

                    :

                    <div className={classes.TimeSection}>
                        <p>{`${currentHour}:${currentMinute}`}</p>
                    </div>
            }



        </div>
    );

}

export default ProductPreview;